import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { batchRequest, getRequest } from '../../../../../../api/ApiService';
import Auth from '../../../../../../routes/Auth';

import { getProductNameColor, getProductRowColor } from '../../../../../../api/PerformanceFeedback';
import { handleSelectChange } from '../../../utils';

import {
  Table,
  Row,
  Cell
} from '../../../components/ui';

import BannerLayout from '../../../layouts/banner';

class MarketShareStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      products: []
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(
      `${process.env.REACT_APP_API_URL}teams/`
    ).then(res => {

      const teamsPriceRangeFailed = performanceFeedbacksGame.find(i => i.type === "Price range failed").teams;
      const didNotSubmit = performanceFeedbacksGame.find(i => i.type === "Did not submit");
      const insufficientCapital = performanceFeedbacksGame.find(i => i.type === "Insufficient capital");

      let teamsToShowIds = [];
      if (didNotSubmit || insufficientCapital) {
        const teamsDidNotSubmit = didNotSubmit ? didNotSubmit.teams : [];
        const teamsInsufficientCapital = insufficientCapital ? insufficientCapital.teams : [];
        teamsToShowIds = teamsPriceRangeFailed.filter(teamPriceRangeFailed => !teamsDidNotSubmit.includes(teamPriceRangeFailed) && !teamsInsufficientCapital.includes(teamPriceRangeFailed));
      } else {
        teamsToShowIds = teamsPriceRangeFailed;
      }

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      batchRequest([
        `${process.env.REACT_APP_API_URL}team/products/?round_number=${activeRound}&team_id=${team_id}`,
        `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}&team_id=${team_id}`
      ]).then(res => {
        const products = res[0].body;

        const productsFiltered = products.filter(i => Number(i.round) === roundId);

        const priceForecasts = res[1].body;

        const productsWithForecast = productsFiltered.map(productFiltered => {
          const priceForecast = priceForecasts.find(priceForecast => priceForecast.product === productFiltered.id);
          return (
            {
              name: productFiltered.name,
              pixels_rank: productFiltered.pixels_rank,
              sensitivity_rank: productFiltered.sensitivity_rank,
              power_rank: productFiltered.power_rank,
              temp_range_rank: productFiltered.temp_range_rank,
              price: priceForecast ? priceForecast.price : 0
            }
          )
        });

        this.setState({
          loaded: true,
          teamsToShow,
          selectedTeamId: Number(team_id),
          allTeamsCount: teams.length,
          products: productsWithForecast
        })
      })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      products
    } = this.state;

    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Market share"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams set at least one of their products’ selling prices outside of what the customer is willing to pay`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            These teams should review the Customer Analysis page to ensure that their marketing mix is aligned with customers’ preferences.
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <Table>
              <Row background="#2a4169">
                <Cell color="#ffffff" />
                <Cell color="#ffffff">Price</Cell>
                <Cell color="#ffffff">Resolution</Cell>
                <Cell color="#ffffff">Sensitivity</Cell>
                <Cell color="#ffffff">Power</Cell>
                <Cell color="#ffffff">Temp Range</Cell>
              </Row>
              {products.map((product, index) => (
                <Row background={getProductRowColor(index)} key={index}>
                  <Cell
                    color="rgba(0, 27, 59, 0.94)"
                    background={getProductNameColor(index)}
                    align="left"
                  >
                    {product.name}
                  </Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">
                    {product.price.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                      maximumFractionDigits: 2,
                    })}
                  </Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.pixels_rank}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.sensitivity_rank}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.power_rank}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.temp_range_rank}</Cell>
                </Row>
              ))}
            </Table>
          </Fragment>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default MarketShareStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/market-share/step2.js